import { IInbox } from "@/shared/services/interface/responses/IInboxResponses";
import { GetActivityTexts, GetInboxDisplayTexts } from "../../../mail/helper/list-item-helper";
import { useTranslation } from "react-i18next";
import { FemaleAvatar } from "@/shared/components/demo-utils/avatars/avatars";
import { formatDistanceToNowStrict } from "date-fns";
import { tr } from "date-fns/locale";
import { IActivity } from "./activity-items-expandible";

interface IActivityItemProps {
  activity: IActivity;
  targetId: string;
}

export default function ActivityItem({ activity, targetId }: IActivityItemProps) {
  const { t } = useTranslation();
  const mockInbox: IInbox = {
    id: activity.activityId,
    createdAt: activity.createdAt,
    updatedAt: activity.createdAt,
    deletedAt: activity.deletedAt,
    userId: "",
    targetId: targetId,
    type: activity.type as any,
    isFavorite: false,
    metadata: activity.metadata || {} as any,
    isRead: false,
  };

  const activityTexts = GetActivityTexts(
    mockInbox,
    activity.type as any,
    t,
    mockInbox
  );

  const inboxDisplayTexts = GetInboxDisplayTexts(
    activity.type as any,
    activity.metadata as any,
    t,
    false
  );

  const timeAgoShort = (date: string | Date) => {
    const raw = formatDistanceToNowStrict(new Date(date), {
      locale: tr,
    });
    // örn: "2 minutes"

    const [value, unit] = raw.split(" ");
    return `${value} ${unit ?? ""}`;
  }


  const title = activityTexts?.title || "";
  const description = inboxDisplayTexts.description || "";

  return (
    <div
      key={activity.activityId}
      className="flex gap-[4px] items-start justify-center p-[8px] rounded-[8px] w-full"
    >
      <div
        className="size-[16px] border border-white rounded-full flex items-center justify-center shrink-0"
      >
        <FemaleAvatar />
      </div>
      <div className="flex-1 flex flex-col items-start justify-center px-[4px] py-0">
        {!description && <div dangerouslySetInnerHTML={{ __html: title || "" }} className="text-[12px] font-regular text-muted-foreground leading-[16px]">
        </div>}
        <div dangerouslySetInnerHTML={{ __html: description || "" }} className="text-[12px] font-regular text-muted-foreground leading-[16px]">
        </div>
      </div>
      <div className="flex flex-col items-start pl-[4px] pr-0 py-0 text-right w-[58.75px]">
        <div className="text-[11px] ml-auto font-[600] text-[#A1A1AA] leading-[16px]">
          {timeAgoShort(activity.createdAt)}
        </div>
      </div>
    </div>
  );
}